import { ICandle, ICandles } from "../storyFace.types";
import { Avatar } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { Typography } from "@atoms";
import moment from "moment/moment";
import { Candle } from "../storyFace.styles";
import CandleIcon from "@assets/icons/candle.svg";
import React from "react";
import { useTranslation } from "react-i18next";

const CandleListItem = ({el} : {el: ICandle}) => {
  const { t } = useTranslation();
  return (
    <div
      className="light-people"
      style={{
        display: "flex",
        justifyContent: "space-between",
        borderTop: "1px solid #E4D7CD",
        padding: "18px 0",
      }}
    >
      <div style={{display: "flex", gap: "8px", alignItems: "center"}}>
        <Avatar
          size={32}
          style={{
            background: "rgba(178, 155, 132, 0.3)",
          }}
          icon={
            el.user.image ? (
              <img src={el.user.image} alt="avatar"/>
            ) : (
              <UserOutlined/>
            )
          }
        />
        <div style={{display: "flex", flexDirection: "column"}}>
          <Typography as="label">
            {el.user.username}
          </Typography>
          <Typography
            as='small'
            style={{
              color: "#391D0A",
            }}
          >
            {moment(el.created_at).format("DD.MM.YYYY")}
          </Typography>
        </div>
      </div>
      <div style={{display: "flex", gap: "8px", alignItems: "center"}}>
        <Candle style={{paddingRight: "10px"}}>
          <img src={CandleIcon} alt="candle"/>
          <div>{el.energy_amount}</div>
        </Candle>

        <Candle
          style={{padding: "0 10px", height: "35px"}}
        >
          <div>
            {el.candle_lifetime_days} {t("days")}
          </div>
        </Candle>
      </div>
    </div>
  );
}

export default CandleListItem;
